import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import CommentsIcon from '../../../base/assets/icons/CommentsIcon';
import Info from '../../../base/assets/icons/Info';
import OrdersIcon from '../../../base/assets/icons/OrdersIcon';
import ProductsIcon from '../../../base/assets/icons/ProductsIcon';
import ProfileIcon from '../../../base/features/micro/ProfileIcon';
import { MAIN_COLOR, TEXT_WHITE_COLOR } from '../../../base/utils/css_constants';
import { navigate_to_cart } from '../../../navigator/user/cart';
import { getShopUid, isSiteDomain } from '../../../settings/domainManager';

class ShopNavBottom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      path_url: window.location.pathname,
      shop_uid: getShopUid(),
    };
  }
  render() {
    return (
      <div className="container" dir="rtl">
        <div
          className="row mx-0 text-center position-fixed py-1 px-2 shadow-lg nav_bottom"
          style={{
            height: "65",
            bottom: "20px",
            right: "20px",
            left: "20px",
            zIndex: "9999999",
            borderRadius: "50px",
            backgroundColor:
              this.props?.personalize?.button_navigation_primary_color ??
              MAIN_COLOR,
          }}
        >
          <div className="col p-1 align-self-center">
            <span
              className="btn p-0"
              onClick={() => this.props.changePath("home")}
            >
              <Info selected={this.props.path === "home" ? true : false} />
              <span
                className="fs-7 d-block mt-1"
                style={{
                  color:
                    this.props?.personalize
                      ?.button_navigation_secondary_color ?? TEXT_WHITE_COLOR,
                }}
              >
                فروشگاه
              </span>
            </span>
          </div>
          {(!this.props.personalize ||
            this.props?.personalize?.products_visible) && (
            <div className="col p-1 align-self-center">
              <span
                className="btn p-0"
                onClick={() => this.props.changePath("products")}
              >
                <ProductsIcon
                  selected={this.props.path === "products" ? true : false}
                />
                <span className="fs-7 text-white d-block mt-1">
                  {(this.props.personalize &&
                    this.props.personalize.product_title) ||
                    "محصولات"}
                </span>
              </span>
            </div>
          )}
          {(!this.props.personalize || this.props.personalize.cart_visible) && (
            <div className="col p-1 align-self-center">
              <Link to={navigate_to_cart()} className="btn p-0">
                <span className="btn p-0">
                  <img
                    alt="shop-cart-icon"
                    className="mb-1"
                    width="22"
                    src={
                      require(`../../../base/assets/icons/shop-cart${
                        this.props.path === "cart" ? "-fill" : ""
                      }-icon.svg`).default
                    }
                  />
                  <span className="fs-7 text-white d-block">سبد خرید</span>
                </span>
              </Link>
            </div>
          )}
          {(!this.props.personalize ||
            this.props.personalize.comments_visible) && (
            <div className="col p-1 align-self-center">
              <span
                className="btn p-0"
                onClick={() => this.props.changePath("comments")}
              >
                <CommentsIcon
                  selected={this.props.path === "comments" ? true : false}
                />
                <span className="fs-7 text-white d-block mt-1">نظرات</span>
              </span>
            </div>
          )}
          {(!this.props.personalize ||
            this.props.personalize.orders_visible) && (
            <div className="col p-1 align-self-center">
              <span
                className="btn p-0"
                onClick={() =>
                  this.props.changePath(!isSiteDomain ? "orders" : "profile")
                }
              >
                {isSiteDomain ? (
                  <ProfileIcon
                    selected={this.props.path === "orders" ? true : false}
                  />
                ) : (
                  <OrdersIcon
                    selected={this.props.path === "orders" ? true : false}
                  />
                )}

                <span className="fs-7 text-white d-block mt-1">
                  {isSiteDomain ? "پروفایل" : "سفارشات"}
                </span>
              </span>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default ShopNavBottom;
